/**
 * Returns a Map of cookie keys and values by splitting
 * @return {Map} the cookies
 */
function getCookies() {
	return global.document ? new Map(global.document.cookie.split(/; ?/).map((pair) => pair.split('='))) : new Map([]);
}

export default getCookies;
